import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Title = styled.span<{ $isEditable: boolean }>`
  margin-top: ${({ $isEditable }): string => ($isEditable ? '13px' : '0')};
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[2]};
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 21px;

  & > * {
    &:not(:first-child) {
      padding-top: 32px;
    }
  }
`;
